import { Pipe, PipeTransform } from '@angular/core';
import { LicenseCode } from '@account-users/account/models/LicenseCode';
import { UserLicencePermission } from '@account-users/account/models/LicensePermissionList';

@Pipe({ name: 'hasPermissionPipe' })
export class HasPermissionPipe implements PipeTransform {
  transform(
    licenseCode: LicenseCode,
    permission: string,
    accountUserLicensePermissions: UserLicencePermission[],
  ): boolean {
    const userLicensePermissions = accountUserLicensePermissions.find(
      (tp) => tp.code === licenseCode,
    );

    return !!(
      userLicensePermissions &&
      userLicensePermissions.permissions
        .map((p) => p.permission)
        .includes(permission)
    );
  }
}
